export default __webpack_public_path__ + "e697cf790ee175ffb501618fdfe68a1f.svg";